import React from 'react';
import classes from './VkAuth.module.scss';
import { athena_state } from 'helpers/oauth2';
import { useAppSelector } from 'store/hook';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import auth from 'api/auth';
import { saveTokensAfterAuthentication } from 'helpers/cookies';
import { functionCollectBrowserData } from 'helpers/browserData/functionCollectBrowserData';

const client_id = window.REACT_APP_VK_CLIENT_ID !== 'REPLACE_REACT_APP_VK_CLIENT_ID' ? window.REACT_APP_VK_CLIENT_ID : process.env.REACT_APP_VK_CLIENT_ID || '';

const VkRegister = () => {
  const { messageApi } = useAppSelector((state) => state.windowState);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const getVkTokens = async (params: any) => {
    const code_verifier = String(localStorage.getItem('code_verifier'));
    const redirect_uri = window.location.origin;
    const room_id = localStorage.getItem('invite_room_id') || undefined;
    const group_id = localStorage.getItem('invite_group_id') || undefined;
    const invite_id = localStorage.getItem('invite_id') || undefined;
    const invite_type = localStorage.getItem('invite_type') || undefined;

    if (params.state === athena_state) {
      const browserData = await functionCollectBrowserData();

      try {
        const response = await auth.externalAuthRegister({
          data: {
            pkce_auth_data: {...params, code_verifier, redirect_uri, client_id},
            service_name: 'vk',
            room_id,
            group_id,
            invite_id,
            invite_type,
          },
          browser_data: JSON.stringify(browserData)
        });
        saveTokensAfterAuthentication(response.data);
        messageApi?.success(t('login.external.successRegister', {name: t('login.external.btns.vk')}), 10);
        localStorage.setItem('need_to_ckeck_profile', 'true');
        navigate('/');
      } catch (error: any) {
        if (error?.response?.data?.detail?.message === 'Email already registered') messageApi?.error(t('login.external.errorEmailExist'), 10);
        else messageApi?.error(t('login.external.errorRequestDataRegister', {name: t('login.external.btns.vk')}), 10);
        navigate('/signup');
      } finally {
        localStorage.removeItem('code_verifier');
        localStorage.removeItem('invite_room_id');
        localStorage.removeItem('invite_group_id');
        localStorage.removeItem('invite_id');
        localStorage.removeItem('invite_type');
      }
    }
  };

  React.useEffect(() => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const paramsObject = Object.fromEntries(urlParams.entries());
      if (paramsObject?.device_id && paramsObject?.code) {
        getVkTokens({ code: paramsObject?.code, device_id: paramsObject?.device_id, state: paramsObject?.state });
      }
    };
  }, [window.location.search]);
  
  return (
    <div id='root'>
      <div className={classes.lds}><div className={classes.ldsRipple}><div></div><div></div></div></div>
    </div>
  );
}

export default VkRegister;

